import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from './UserAppResource';
import EmailCampaignAppResource from "./EmailCampaignAppResource";

export const COMPLETE_PROFILE = '91722b97-9671-40ad-9e7d-1148a81a2a51';
export const CREATE_HUB = '41df3e7a-6c34-4947-80eb-2c32befb58d3';
export const IMPORT_CONTACTS = '36f181ec-97a7-4b0f-be21-895670ab1738';
export const FEATURE_FAVORITE_PROS = '6a354a1f-caf5-4843-adbe-963012a39baa';
export const ONBOARD_HOMEOWNERS = '46acd309-c3d7-4d6b-907d-70fee1f06c75';

class ProOnboardingStepAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'pro-onboarding-step';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'pros/onboardings/steps';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
            'summary',
            'sort',
            'enabled',
            'hidden',
            'emailCampaignUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            emailCampaign: EmailCampaignAppResource,
            users: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            emailCampaign: 'email_campaign_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
            },
            title: {
                type: 'string',
                presence: true,
            },
            description: {
                type: 'string',
                presence: true,
            },
            summary: {
                type: 'string',
                presence: true,
            },
            sort: {
                type: 'number',
                presence: true,
            },
            enabled: {
                type: 'boolean',
                presence: true,
            },
            hidden: {
                type: 'boolean',
                presence: true,
            },
            email_campaign_uuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default ProOnboardingStepAppResource;
